import React from "react";

//Importing Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

//Importing Components
import { OutlinedButton } from "../../components/Buttons";
import DesignCards from "../../components/About/DesignCards";
import AboutCards from "../../components/About/AboutCards";
import MasonryCard from "../../components/About/MasonryCards";

// Importing Assets
import AboutImage from "../../assets/about-page/devraj-chatribin.webp";
import svg1 from "../../assets/about-page/DesignProcess/Strategy.svg";
import svg2 from "../../assets/about-page/DesignProcess/Wireframe.svg";
import svg3 from "../../assets/about-page/DesignProcess/Design.svg";
import svg4 from "../../assets/about-page/DesignProcess/Development.svg";
import svg5 from "../../assets/about-page/DesignProcess/QA.svg";
import trophy from "../../assets/about-page/trophy.svg";
import Competition1 from "../../assets/about-page/ExtraCurricular/bridge building.webp";
import Competition2 from "../../assets/about-page/ExtraCurricular/car lifting machine.webp";
import Competition3 from "../../assets/about-page/ExtraCurricular/catapult competition.webp";
import Competition4 from "../../assets/about-page/ExtraCurricular/line follower robo.webp";
import Competition5 from "../../assets/about-page/ExtraCurricular/photography competition.webp";
import Artwork1 from "../../assets/about-page/ExtraCurricular/dc-vector-art.webp";
import Artwork2 from "../../assets/about-page/ExtraCurricular/model-eyes.webp";
import Artwork3 from "../../assets/about-page/ExtraCurricular/poster-competition.webp";
import Artwork4 from "../../assets/about-page/ExtraCurricular/priyanka.webp";
import Artwork5 from "../../assets/about-page/ExtraCurricular/model-face.webp";
import Artwork6 from "../../assets/about-page/ExtraCurricular/rashmika.webp";
import Artwork7 from "../../assets/about-page/ExtraCurricular/saloni.webp";

import style from "./style";

const AboutPage = () => {
  const useStyles = makeStyles(style);
  const classes = useStyles();

  return (
    <Grid container className="page">
      {/* Hero Section */}
      <Grid container className={`${classes.heroSection}`}>
        <img
          data-aos="fade-in"
          className={`${classes.image}`}
          src={AboutImage}
          alt="About Me"
        />
        <Typography data-aos="fade-in" variant="h1" className={classes.title}>
          Devraj Chatribin.
        </Typography>

        <Typography data-aos="fade-in" variant="h6" gutterBottom className={classes.heroPara}>
          A self-motivated, ambitious person with creative, and adaptable nature. My aim is to apply my skills and knowledge in the betterment of the organization and to work collaboratively with others towards an objective of professional excellence.
        </Typography>

        <div className={`${classes.btns}`}>
          <span className="hover-detect">
            <OutlinedButton data-aos="fade-in" target="_blank" href="https://docs.google.com/document/d/1Gt9kTDOgqljUXPw6nbJGGiKxbST5IjEY/edit?usp=sharing&ouid=117389983527332462346&rtpof=true&sd=true" size="large">My Resume</OutlinedButton>
          </span>
          <Link to={`/projects`} className="hover-detect">
            <OutlinedButton data-aos="fade-in" size="large">My Projects</OutlinedButton>
          </Link>
        </div>
      </Grid>

      {/* Skill Section */}
      <Grid
        container
        className={`${classes.section}`}
      >
        <Typography
          data-aos="fade-in" data-aos-delay="100"
          variant="h2"
          gutterBottom
          className={classes.secondaryTitle}
        >
          Skills & Tools
        </Typography>

        <Grid container className={`${classes.cardWrapper}`}>
          <AboutCards
            title="Languages"
            description="HTML, CSS, SASS, Bootstrap, JavaScript, C, C++, JAVA."
          />
          <AboutCards
            title="Libraries and Frameworks"
            description="React, Node.js, Express.js, MongoDB, jQuery, Material UI, GSAP, BarbaJS, WebGL, SQL, DBMS."
          />
          <AboutCards
            title="Tools & Platforms"
            description="Git, GitHub, Netlify, Heroku, Vercel, Firebase, Webflow, Google Cloud, VSCode."
          />
          <AboutCards
            title="Creative and Design"
            description="Figma, Adobe XD, Photoshop, Lightroom, Illustrator, Miro, Framer, InVision."
          />
        </Grid>
      </Grid>

      {/* Design Process Section */}
      <Grid
        container
        className={`${classes.section}`}
      >
        <Typography
          data-aos="fade-in"
          variant="h2"
          gutterBottom
          className={classes.secondaryTitle}
        >
          My Design Process
        </Typography>

        <Grid container className={`${classes.cardWrapper}`}>
          <DesignCards
            svg={svg1}
            id="1"
            title="Strategize"
            alt="Strategize"
            description="To create something awesome, one must first talk about the details. Planning is essential."
          />
          <DesignCards
            svg={svg2}
            id="2"
            title="Wireframe"
            alt="Wireframe"
            description="After hashing out the details of the website, it’s easy to throw the ideas onto pen & paper."
          />
          <DesignCards
            svg={svg3}
            id="3"
            title="Design"
            alt="Design"
            description="The most fun part of all - adding pizzaz to the wirefreames and bring it to life."
          />
          <DesignCards
            svg={svg4}
            id="4"
            title="Development"
            alt="Development"
            description="The design may be final but it needs to be functional and practical. Development is key."
          />
          <DesignCards
            svg={svg5}
            id="5"
            title="Quality Assurance"
            alt="Quality Assurance"
            description="Website load times, SEO, file optimization, etc., weigh in to the quality of the site."
          />
        </Grid>
      </Grid>

      {/* Benefits to work with me Section */}
      <Grid
        container
        className={`${classes.section}`}
      >
        <Typography
          data-aos="fade-in" data-aos-delay="100"
          variant="h2"
          gutterBottom
          className={classes.secondaryTitle}
        >
          Benefits of working with me
        </Typography>

        <Grid container className={`${classes.benefitsWrapper}`}>
          <Grid>
            <Typography variant="h2" data-aos="fade-in" className={`${classes.num}`}>01</Typography>
            <Typography variant="h5" data-aos="fade-in" className={classes.subTitle}>Time zone isn’t a barrier</Typography>
            <Typography variant="h6" data-aos="fade-in" gutterBottom className={classes.description}>
              Working with me, time isn’t a problem wherever you are in the world, I get things done for you. Whatever your business problem is, I am ready to solve, time differences don’t matter.
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="h2" data-aos="fade-in" className={`${classes.num}`}>02</Typography>
            <Typography variant="h5" data-aos="fade-in" className={classes.subTitle}>Wide range of services</Typography>
            <Typography variant="h6" data-aos="fade-in" gutterBottom className={classes.description}>
              I believe in building better products and experiences that improve people’s lives. I come with a wide range of experience in websites and mobile app designing, development, branding, and saas products.
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="h2" data-aos="fade-in" className={`${classes.num}`}>03</Typography>
            <Typography variant="h5" data-aos="fade-in" className={classes.subTitle}>Bring in the WOW element</Typography>
            <Typography variant="h6" data-aos="fade-in" gutterBottom className={classes.description}>
              I believe in magic and creating magic through my work. I take pride in creating wow experiences more than anything. My uniqueness is my magic and I’m not afraid to be a version of myself.
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="h2" data-aos="fade-in" className={`${classes.num}`}>04</Typography>
            <Typography variant="h5" data-aos="fade-in" className={classes.subTitle}>Flexible in every-way</Typography>
            <Typography variant="h6" data-aos="fade-in" gutterBottom className={classes.description}>
              I believe I’m different from others. The budget won’t be a problem as I’m quite flexible about it. I believe in solving your problems and rest assured I can work everything outright from the first call.
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Achievements Section */}
      <Grid
        container
        className={`${classes.section}`}
      >
        <Typography
          data-aos="fade-in"
          variant="h2"
          gutterBottom
          className={classes.secondaryTitle}
        >
          Achievements
        </Typography>

        <Grid container className={`${classes.achievementCardWrapper}`}>
          <DesignCards
            type="Achievement"
            svg={trophy}
            alt="trophy"
            title="Star Performer of the Year"
            description="Awarded for my major contribution to the community as a Web Developer, Graphic Designer and organizing several events and programs."
          />
          <DesignCards
            type="Achievement"
            svg={trophy}
            alt="trophy"
            title="Hackathon Winner"
            description="Best Beginner Hack Winner at Hack At Home II Hackathon organized by MLH (Major League Hacking)."
          />
          <DesignCards
            type="Achievement"
            svg={trophy}
            alt="trophy"
            title="Sketch Webpage Contest Winner"
            description="Won the 'Sketch Webpage' contest, organized by GirlScript Pilani. Awarded for making best website and hosting it on a hosting platform."
          />
          <DesignCards
            type="Achievement"
            svg={trophy}
            alt="trophy"
            title="Hackathon Winner"
            description="Best Space App powered by US Space Force Winner at Peace Out Hacks organized by MLH (Major League Hacking)."
          />
        </Grid>
      </Grid>


      {/* Instagram grid */}
      <Typography
        data-aos="fade-in"
        variant="h2"
        gutterBottom
        className={classes.secondaryTitle}
      >
        Instagram Gallery
      </Typography>
      <div data-aos="fade-in" data-aos-delay="200" class="elfsight-app-36fd7734-3d94-48c6-a61c-0b9316f2ef9a"></div>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <a href="https://www.instagram.com/devrajchatribin" target="_blank" rel="noreferrer" className="hover-detect">
          <OutlinedButton data-aos="fade-in" size="large">View All Posts</OutlinedButton>
        </a>
      </div>

      {/* Extra-Curricular Section */}
      <Grid
        container
        className={`${classes.section}`}
      >
        <Typography
          data-aos="fade-in" data-aos-delay="100"
          variant="h2"
          gutterBottom
          className={classes.secondaryTitle}
        >
          Extracurricular
        </Typography>

        <div className={classes.subWrapper}>
          <Typography data-aos="fade-in" data-aos-delay="200" variant="h5" gutterBottom className={classes.subTitle}>
            My Competitions
          </Typography>

          <Typography data-aos="fade-in" data-aos-delay="300" variant="h6" gutterBottom className={classes.sTitle}>
            Apart from developing and designing sites, i have been participating in various other competitions. Below are few competitions that i have won.
          </Typography>

          <div container data-aos="fade-in" className={`${classes.masonryWrapper}`}>
            <MasonryCard image={Competition1} text="" />
            <MasonryCard image={Competition2} text="" />
            <MasonryCard image={Competition3} text="" />
            <MasonryCard image={Competition4} text="" />
            <MasonryCard image={Competition5} text="" />
          </div>
        </div>

        <div className={classes.subWrapper}>
          <Typography data-aos="fade-in" data-aos-delay="100" variant="h5" gutterBottom className={classes.subTitle}>
            My Artworks
          </Typography>

          <Typography data-aos="fade-in" data-aos-delay="200" variant="h6" gutterBottom className={classes.sTitle}>
            Fun Fact about me, I am an artist as well. I do all kinds of art including paintings, poster, sketch etc. in holidays or free time. Here’s a preview of some artworks.
          </Typography>

          <div data-aos="fade-in" className={`${classes.masonryWrapper}`}>
            {/*if grid doesn't work, use div */}
            <MasonryCard image={Artwork1} text="" />
            <MasonryCard image={Artwork2} text="" />
            <MasonryCard image={Artwork3} text="" />
            <MasonryCard image={Artwork4} text="" />
            <MasonryCard image={Artwork5} text="" />
            <MasonryCard image={Artwork6} text="" />
            <MasonryCard image={Artwork7} text="" />
          </div>
        </div>
        <Typography data-aos="fade-in" data-aos-delay="200" variant="h6" gutterBottom className={classes.heroPara}>
          Wow ! You have read so much about me, now you can connect with me
          directly and tell me your interests and more about you. Would love to
          hear that from you!
        </Typography>

      </Grid>
    </Grid>
  );
};

export default AboutPage;